/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetsMelcoModelsHoopMachine
 */
export interface AssetsMelcoModelsHoopMachine {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopMachine
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopMachine
     */
    name?: string | null;
}

export function AssetsMelcoModelsHoopMachineFromJSON(json: any): AssetsMelcoModelsHoopMachine {
    return AssetsMelcoModelsHoopMachineFromJSONTyped(json, false);
}

export function AssetsMelcoModelsHoopMachineFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsHoopMachine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function AssetsMelcoModelsHoopMachineToJSON(value?: AssetsMelcoModelsHoopMachine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


